<app-project-submenu></app-project-submenu>

<p
  class="text-muted mt-3 mb-3"
  i18n="@@bot-communication-description"
  >
  Übersicht aller aktiven Bot-Gruppenchatkanäle. Klicke auf einen Kanal, um den Chatverlauf einzusehen.
</p>

<p-table
  [value]="this.chatChannels"
  [rowHover]="true"
  class="p-datatable-m"
  >
  <ng-template #header>
    @if (this.chatChannels.length > 0) {
      <tr>
        <th i18n="@@channel-column">Kanal</th>
        <th i18n="@@participating-bots-column">Beteiligte Bots</th>
        <th i18n="@@message-count-column">Nachrichten</th>
        <th i18n="@@last-activity-column">Letzte Aktivität</th>
      </tr>
    }
  </ng-template>

  <ng-template
    #body
    let-channel
    >
    <tr
      style="cursor: pointer"
      (click)="openChannel(channel.channel)"
      >
      <td><strong>{{ channel.channel }}</strong></td>
      <td>{{ channel.bots.join(', ') }}</td>
      <td>{{ channel.messageCount }}</td>
      <td>{{ channel.lastActivity | date:'dd.MM.yyyy HH:mm' }}</td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td
        colspan="4"
        class="text-center p-5 text-muted"
        i18n="@@bot-communication-empty-state"
        >
        Noch keine Bot-Gruppenchats vorhanden. Sobald Bots Nachrichten über Kanäle senden, erscheinen sie hier.
      </td>
    </tr>
  </ng-template>
</p-table>
